
@switch (level) {
  @case (1) {
    <h2 class="blog-block-heading blog-block-heading--large">
      {{ block.text }}
    </h2>
  }
  @case (2) {
    <h3 class="blog-block-heading blog-block-heading--medium">
      {{ block.text }}
    </h3>
  }
  @case (3) {
    <h4 class="blog-block-heading blog-block-heading--small">
      {{ block.text }}
    </h4>
  }
}
